import { AfterViewInit, Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ITableDriftSummaryDto } from '../../../../models/features/schema-drift/ITableDriftSummaryDto';
import { HeaderService } from '../../../../services/_app/header/header.service';
import { SchemaDriftService } from '../../../../services/_app/schema-drift/schema-drift.service';
import { AuditProfileService } from '../../../../services/audit-profile/audit-profile.service';
import { BaseComponent } from '../../../base/base.component';
import { IDriftEntryDto } from '../../../../models/features/schema-drift/IDriftEntryDto';

@Component({
  selector: 'app-schema-drift-list',
  templateUrl: './schema-drift-list.component.html',
  styleUrls: ['./schema-drift-list.component.css']
})
export class SchemaDriftListComponent extends BaseComponent implements OnInit, AfterViewInit {
  // *********************
  // variables declaration
  // *********************

  // private
  // ********

  // public
  // ******
  @Input() driftData: any;

  public databaseName: string = '...';
  public skeleton: boolean = true;
  public sortedColumn: keyof IDriftEntryDto | '' = '';
  public sortAscending: boolean = true;
  public isGridShow: boolean = true;
  public all: boolean = false;
  public isPreviewDataSelected: boolean = false;
  public lastDriftDate: string = '';
  public lastDriftTime: string = '';

  constructor(private auditProfileService: AuditProfileService,
    private headerService: HeaderService,
    private schemaDriftService: SchemaDriftService,
    private router: Router) {
    super();
  }

  // ***************
  // lifecycle hooks
  // ***************
  override async ngOnInit() {
    await this.housekeeping();
  }

  ngAfterViewInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('DriftTrendChartComponent - ngOnChanges', changes);
    if (changes['driftData']) {
      this.tryBuild();
    }
  }

  // *******
  // methods
  // *******

  // public
  // ******
  public showTableData(tableName: ITableDriftSummaryDto) {
    //this.PreviewDataTableSchema = record.tableSchema;
    //this.PreviewDataTableName = record.tableName;
    this.isPreviewDataSelected = true;
    // get from LighthouseDashboardComponent
  }

  public sortByColumn(columnName: keyof IDriftEntryDto): void {
    debugger;
    const isSameColumn = this.sortedColumn === columnName;
    this.sortAscending = isSameColumn ? !this.sortAscending : true;
    this.sortedColumn = columnName;

    const getComparableValue = (row: IDriftEntryDto): number | string => {
      const value = row[columnName] as any;

      if (columnName === 'date') {
        if (!value) return 0;

        const time = value instanceof Date ? value.getTime() : new Date(value).getTime();

        return isNaN(time) ? 0 : time;
      }

      return value ?? '';
    };

    this.driftData.FilteredTableDriftSummary.sort((a: any, b: any) => {
      const av = getComparableValue(a);
      const bv = getComparableValue(b);

      if (typeof av === 'number' && typeof bv === 'number') {
        const result = av - bv;

        return this.sortAscending ? result : -result;
      }

      const result = String(av).localeCompare(String(bv), undefined, { numeric: true, sensitivity: 'base' });

      return this.sortAscending ? result : -result;
    });
  }

  public close(event: boolean) {
    this.isPreviewDataSelected = false;
  }

  // private
  // *******
  private async housekeeping() {
    this.skeleton = false;
  }

  private tryBuild(): void {
    const entries = this.driftData;
    debugger;

    if (!entries || entries.length === 0) {
      this.lastDriftDate = '';
      this.lastDriftTime = '';

      return;
    }

    const index = entries.length - 1;
    const dateStr: string = entries[index]?.Date ?? '';

    this.lastDriftDate = dateStr;
    this.lastDriftTime = this.extractUtcTimeFromIso(dateStr);
  }

  private extractUtcTimeFromIso(dateStr: string): string {
    if (!dateStr) return '';

    // Normalize ISO string to ensure at most 3 fractional second digits for JS Date parsing.
    const normalized = dateStr.replace(/\.(\d+)(Z)$/, (_m, frac: string, z: string) => {
      const ms = frac.substring(0, 3).padEnd(3, '0');
      return `.${ms}${z}`;
    });

    const d = new Date(normalized);
    if (isNaN(d.getTime())) return '';

    const pad = (n: number) => n.toString().padStart(2, '0');
    return `${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())}:${pad(d.getUTCSeconds())}`;
  }

}

